import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';
import { ValidatedMethod } from 'meteor/mdg:validated-method';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { DDPRateLimiter } from 'meteor/ddp-rate-limiter';
import _ from 'lodash';
import { Alerts } from '../alerts/alerts';
import { Roles } from 'roles';
import moment from 'moment';

export const updatePassword = new ValidatedMethod({
	name: 'users.updatePassword',
	validate: new SimpleSchema({
		_id: { type: String },
		password: { type: String, min: 8 },
	}).validator(),
	run({ _id, password }) {
		if (!Roles.userHasPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id)))
			throw new Meteor.Error('unauthorized',
									'Vous ne pouvez pas modifier ce mot de passe.');

		if (Meteor.isServer)
			Accounts.setPassword(_id, password, { logout: false });

		return true;
	},
});

export const updateCertificat = new ValidatedMethod({
	name: 'users.updateCertificat',
	validate: new SimpleSchema({
		_id: { type: String },
		certificat: { type: String },
	}).validator(),
	run({ _id, certificat }) {
		if (!Roles.userHasPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id)))
			throw new Meteor.Error('unauthorized',
									'Vous ne pouvez pas modifier ce certificat.');
		if (Meteor.isServer)
			Meteor.users.update(_id, { "$set": {'profile.certificat': certificat}});

		let user = Meteor.user();

		Alerts.remove({to_users: [user._id], ref: 'certificat'});

		let alert = {
			content: 'Le certificat médical de ' + user.profile.firstName + ' ' + user.profile.lastName + ' expire le ' + moment(certificat).format('DD/MM/YYYY'),
			from: moment(certificat).subtract(30, 'days').format().toString(),
			to: moment(certificat).add(5, 'days').format().toString(),
			ref: 'certificat',
			to_users: [user._id],
			to_type: ['organizer', 'god'],
			type: "Alerte"
		}
		Alerts.insert(alert);

		return true;
	},
});

export const updateLicence = new ValidatedMethod({
	name: 'users.updateLicence',
	validate: new SimpleSchema({
		_id: { type: String },
		licence: { type: String },
	}).validator(),
	run({ _id, licence }) {
		if (!Roles.userHasPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id)))
			throw new Meteor.Error('unauthorized',
									'Vous ne pouvez pas modifier cette licence.');
		if (Meteor.isServer)
			Meteor.users.update(_id, { "$set": {'profile.licence': licence}});

		let user = Meteor.user();

		Alerts.remove({to_users: [user._id], ref: 'licence'});

		let alert = {
			content: 'La licence pilote de ' + user.profile.firstName + ' ' + user.profile.lastName + ' expire le ' + moment(licence).format('DD/MM/YYYY'),
			from: moment(licence).subtract(30, 'days').format().toString(),
			to: moment(licence).add(5, 'days').format().toString(),
			ref: 'licence',
			to_users: [user._id],
			to_type: ['organizer', 'god'],
			type: "Alerte"
		}
		Alerts.insert(alert);

		return true;
	},
});

export const createUser = new ValidatedMethod({
	name: 'users.create',
	validate: new SimpleSchema({
		username: { type: String, min: 4 },
		password: { type: String },
		email: { type: String },
		profile: { type: Object, blackbox: true },
		roles: { type: [String], label: "roles" }
	}).validator(),
	run({ username, password, email, profile, roles }) {
		Roles.checkPermission(Meteor.userId(), "users.insert", { username, password, email, profile, roles });

		if (Meteor.isServer) {
			const userId = Accounts.createUser({ username, password, email, profile });
			Roles.setUserRoles(userId, roles);
		}
	},
});

export const getPartners = new ValidatedMethod({
	name: 'get.partners',
	validate: new SimpleSchema({}).validator(),
	run() {
		Roles.checkPermission(Meteor.userId(), "users.insert", { username, password, email, profile, roles });

		console.log('TEST GET');

		if (Meteor.isServer) {
			return Meteor.users.find({roles:{$in:['partner']}, 'profile.billType': 'groupe'});
		}
	},
});

// Get list of all method names on Lists
const LISTS_METHODS = _.map([
	updatePassword,
	createUser,
	getPartners
], 'name');

if (Meteor.isServer) {
  // Only allow 5 list operations per connection per second
  DDPRateLimiter.addRule({
    name(name) {
      return _.includes(LISTS_METHODS, name);
    },

    // Rate limit per connection ID
    connectionId() { return true; },
  }, 5, 1000);
}



/** WEBPACK FOOTER **
 ** ./src/universal/collections/users/methods.js
 **/